/* RB quick add (sprint 1, Oct 2026): "+ הוספה" on product tiles → a size sheet → RB Cart, in 3 taps:
   "+ הוספה" (1) → a size (2) → "הוספה לסל" (3). The sheet then closes and the RB Cart drawer opens.
   Sets (Oct 21, Amit: "one item alone looks expensive"): products with set prices get a "כמות" choice above the sizes,
   "יחידה אחת · ₪110" / "סט של 2 · ₪210" / "סט של 3 · ₪309" with the price per item and the saving. A set is 4 taps:
   "+ הוספה" → "סט של 3" → a size → "הוספה לסל · ₪309". The size/colour pills are item 1; items 2..N get compact rows
   with native selects that copy item 1 (size and colour) until the shopper changes them.
   - Tiles print <a class="rb-qa-btn" href="<product>" data-rb-qa-open="<product id>" [data-rb-qa-color] [data-rb-qa-preset]>
     (snippets/rb-quick-add-btn). Once RB Cart is ready this script swaps each one for a <button> with the same look, so
     with no JS, or no RB Cart (the /cart page), the tile simply links to the product. Nothing on the card moves.
   - Product data: <script type="application/json" data-rb-qa="<id>"> (snippets/rb-quick-add-data) in the same section.
     While the sheet is open, availability is re-checked in the background with /products/<handle>.js.
   - One shared native modal <dialog id="RBQA"> (snippets/rb-quick-add): inert page behind it, Esc closes, Tab wraps
     inside it, focus returns to the tile; html.rb-qa-lock locks page scroll (and keeps the signup pop-up away).
   - Choices are radio "pills" (a <select> costs an extra tap on iPhone). Colour: fixed to the tile's colour on
     collection cards (only the size is asked), else it starts on the card's colour / the first one in stock.
   - Sold-out rule = RB Cart's set picker (assets/rb-cart.js decorateSet/settleSet): a size is sold out only when no
     colour has it (with a fixed colour: when that colour hasn't); colours are checked against the chosen size, and a
     size change moves the colour to the first one in stock (announced). Sold-out pills are disabled + "אזל".
   - Set prices: data "ts" = [[qty, price in agorot], …] from the metafield rellibaby.bundle_tiers (the same list the
     product page set picker reads). The cart price comes from the automatic discounts "סט של N" (fixed amount off each
     item, minimum N of that product, any size/colour mix), so adding N items is all it takes. Unit price = the picked
     variant's price (else the first available one's, like snippets/rb-bundles); saving = unit × N − set price.
     Nothing is hard-coded; a product without tiers shows no "כמות" choice. Never a "was" price (except the ShoppingIL
     sale's regular price, below).
   - The add: window.RBCart.add(items, {source:'tile' | 'quick-add-set', open:false}); identical variants are grouped
     into one {id, quantity}, never more than the stock left (counting the drawer). On success the sheet closes, then
     RBCart.open(tile), so the drawer is never stuck under the modal and focus returns to the tile when it closes.
     Errors (missing size, stock, network) stay in the sheet, in a role=alert line.
   Events on document: rb:qa:open, rb:qa:close (detail.product).
   P3 (Oct 21, 2026, sprint 2, audit "Road to 1.25%"): the sheet seemed to pick a size for the shopper. Sizes always
   started empty, but on open focus went to the first in-stock size pill (e.g. 12–18 months on the long romper), whose
   focus ring looked like a choice, and the button already read "הוספה לסל · ₪110". Now:
   - Nothing looks picked: a tap opens the sheet with focus on its title (tabindex -1, no ring); only a keyboard open
     (click with detail 0) goes straight to the size pills, as before, so arrow keys work at once.
   - Until every must-pick option (the size) is chosen, the add button reads "בחרו מידה" (EN "Choose size", strings
     "pick" in snippets/rb-quick-add), looks off (.rb-qa__add.is-pending) and has aria-disabled="true", but stays a
     live button: a tap says why ("בחרו מידה" in the role=alert line) and moves focus to the first size, as before.
     Picking a size turns it into "הוספה לסל · ₪110". Sets: the same until item 1's size is chosen.
   - The colour still starts on the tile's colour (data-rb-qa-color fixed / data-rb-qa-preset, now also set by the
     colour dots of assets/rb-coll.js), else the first one in stock: a colour isn't a size.
   - aria-disabled is now owned by one function (syncAria) for both "no size yet" and "adding…".
   ShoppingIL (Nov 2026, Google Israel's shopping event; the same code runs in the sale theme and the normal one, the
   theme settings decide, and with them off nothing here changes):
   - Sale (rb_sale_pct above 0): the data's "p" / "c" / tier prices are already the sale prices, worked out in Liquid
     with the rounding of snippets/rb-money (snippets/rb-quick-add-data), and "wp" / "wc" / a tier's third number are
     the regular ones. Nothing is recomputed here: every price the sheet shows (the line under the title, each "כמות"
     chip, the add button) is the sale price followed by the regular one struck through, the markup of rb-money
     (.rb-sale, "במקום ₪110" for screen readers). A set's struck price is its own set price (₪231.75 ₪309), never the
     sum of single items, and its "חוסכים" turns into "25% הנחה", as on the product page's set picker. Per item and
     "הכי משתלם" are worked out on the sale prices. Gift cards: no "wp", so no sale.
   - Pre-order (rb_preorder_on, a variant's "po"): a size that leads to a pre-order variant gets a second, smaller line
     "הזמנה מוקדמת" in its pill (never struck or greyed: it's buyable); items 2..N say it in their size lists. When what
     will be added holds a pre-order variant, the add button reads RB_PO.btn and RB_PO.note shows in a calm box right
     above it (role=status, read once); otherwise both go back. Each pre-order variant in the add request carries the
     line property {RB_PO.key: RB_PO.val} (no underscore: checkout, the order, Flow and the emails show it). All the
     words come from window.RB_PO (snippets/rb-po, printed by the layouts).
   Nov 2, 2026 (Amit: "much more polished and clean ... less noise, min words and noise"; styles in rb-quick-add.css):
   - The "כמות" tiles sit side by side and say only the name and the price to pay ("סט של 3" / "₪181.98"); the best
     set adds "הכי משתלם". Gone: the radio dot, the per-item price, "חוסכים ₪X" and, on sale, the struck set price and
     the "% הנחה" line in every tile (the price line under the title and the add button still show the sale price with
     the regular one struck). Accessible name, e.g. "סט של 3, ₪181.98, הכי משתלם".
   - A must-pick option whose values all share one unit ("0-3 חודשים" … "18-24 חודשים") prints the unit once, in its
     legend ("מידה (חודשים)"), and "0-3" in each pill (the unit stays in the pill for screen readers, visually
     hidden), as the shop pages' size filter does. The five baby sizes now fit one row on a phone. Messages and the
     set rows still use the full names. */
(function () {
  if (window.__rbQaLoaded) return;
  window.__rbQaLoaded = true;

  var S = {};
  var dlg, bodyEl, titleEl, priceEl, imgEl, noteEl, msgEl, addBtn, pdpEl, poEl;
  var data = null, opener = null, sel = {}, fixed = {}, cardFixed = {}, busy = false, handoff = false, downOutside = false;
  // busyAt: when the running add started (a hung request must not lock the sheet for ever, see locked()).
  // addRun: bumped on every open, so a late add result never touches a sheet opened for another tile since.
  var busyAt = 0, addRun = 0, msgTimer = 0;
  var LOCK_MS = 10000;
  // Sets: qty = items in the picked choice (1 = one item); tiers = this product's sets [{n, c}]; rows = items 2..qty
  // (rowsAll keeps what was picked when switching 3 → 2 → 3 while the sheet is open); itemsEl = the rows' box;
  // forEls = the "· פריט 1" marks on the pills' legends; rowNotes = colour moves in rows, announced once.
  var qty = 1, tiers = [], rows = [], rowsAll = [], itemsEl = null, forEls = [], rowNotes = [];

  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function el(tag, cls, txt) { var e = document.createElement(tag); if (cls) e.className = cls; if (txt != null) e.textContent = txt; return e; }
  function focusEl(e) { if (!e || !e.focus) return; try { e.focus({ preventScroll: true }); } catch (x) { e.focus(); } }
  function emit(name, detail) { document.dispatchEvent(new CustomEvent(name, { detail: detail || {} })); }
  function go(url) { if (url) window.location.href = url; }
  function cartReady() {
    var r = document.getElementById('rb-cart-root');
    return !!(window.RBCart && typeof window.RBCart.add === 'function' && r && !r.hasAttribute('data-page-cart'));
  }
  function productData(id, from) {
    var sec = from && from.closest && from.closest('.shopify-section');
    var s = (sec && $('script[data-rb-qa="' + id + '"]', sec)) || $('script[data-rb-qa="' + id + '"]');
    if (!s) return null;
    if (s._d === undefined) {
      try { s._d = JSON.parse(s.textContent); } catch (e) { s._d = null; }
      if (s._d && (!Array.isArray(s._d.o) || !Array.isArray(s._d.vs) || !s._d.vs.length)) s._d = null;
    }
    return s._d;
  }
  function note(t) { noteEl.textContent = t || ''; }
  // Clear first, then write a moment later: the same error twice in a row ("בחרו מידה") is announced again, because
  // the alert's text really changes (same pattern as RB Cart's say()).
  function msg(t) {
    clearTimeout(msgTimer);
    msgEl.textContent = '';
    if (t) msgTimer = setTimeout(function () { msgEl.textContent = t; }, 60);
  }
  function errText(e) { return (e && typeof e.description === 'string' && e.description) || S.err; }

  /* ---------- money (the format of snippets/rb-money and RB Cart: ₪110, ₪86.66, ₪269.50) ---------- */
  function money(c) { return '₪' + (Math.round(c) / 100).toFixed(2).replace(/\.00$/, ''); }
  function moneySpan(t, cls) { var s = el('span', 'rb-money' + (cls ? ' ' + cls : ''), t); s.setAttribute('dir', 'ltr'); return s; }
  function moneyEl(c) { return moneySpan(money(c)); }
  // ShoppingIL (Nov 2026): a sale price and the regular one struck through, the markup of snippets/rb-money (sale: true):
  // "₪82.50 ₪110", read "₪82.50 במקום ₪110". Labels (strings); no was label (no sale, a gift card) = the plain price.
  function saleEl(now, was) {
    if (!was || was === now) return moneySpan(now);
    var s = el('span', 'rb-sale');
    s.appendChild(moneySpan(now, 'rb-sale__now'));
    s.appendChild(document.createTextNode(' '));
    var w = el('s', 'rb-sale__was');
    w.appendChild(el('span', 'visually-hidden', S.was + ' '));
    w.appendChild(moneySpan(was));
    s.appendChild(w);
    return s;
  }
  // The same from agorot: c = what the shopper pays, w = the regular price (struck only when it's really higher)
  function pricePair(c, w) { return saleEl(money(c), w != null && w > c ? money(w) : null); }
  // Screen readers get a comma where the eye gets a line break or a "·"
  function pause() { return el('span', 'visually-hidden', ', '); }
  function dotSep(into) {
    var d = el('span', 'rb-qa__sep', '·');
    d.setAttribute('aria-hidden', 'true');
    into.appendChild(d);
    into.appendChild(pause());
  }
  function lc(t) { return String(t || '').toLowerCase(); }   // "Please choose a size" (Hebrew has no case)

  /* ---------- choices (state lives in sel; the radios mirror it) ---------- */
  function optOf(i) { return data.o.filter(function (o) { return o.i === i; })[0] || null; }
  function valOf(o, v) { return o.v.filter(function (x) { return x.v === v; })[0] || null; }
  // Can value `val` of option o still be bought? Fixed options always have to match. Must-pick options (sizes) are
  // checked against nothing else; colours against the sizes already picked.
  function avail(o, val) {
    return data.vs.some(function (v) {
      if (!v.a || v.o[o.i] !== val) return false;
      return data.o.every(function (o2) {
        if (o2.i === o.i) return true;
        if (fixed[o2.i]) return v.o[o2.i] === sel[o2.i];
        if (o.s || !o2.s) return true;
        return sel[o2.i] == null || v.o[o2.i] === sel[o2.i];
      });
    });
  }
  function firstAvail(o) { var x = o.v.filter(function (v) { return avail(o, v.v); })[0]; return x ? x.v : null; }
  function missing() { return data.o.filter(function (o) { return sel[o.i] == null; })[0] || null; }
  function pick() {
    if (!data.o.length) return data.vs[0] || null;
    if (missing()) return null;
    return data.vs.filter(function (v) { return data.o.every(function (o) { return v.o[o.i] === sel[o.i]; }); })[0] || null;
  }
  function inCart(id) {
    return $$('#rb-cart-root .rb-cart__line').reduce(function (n, l) {
      return n + (Number(l.getAttribute('data-variant')) === id ? Number(l.getAttribute('data-qty')) || 0 : 0);
    }, 0);
  }

  /* ---------- ShoppingIL (Nov 2026): pre-order ---------- */
  // window.RB_PO (snippets/rb-po via the layouts) when pre-order is on and complete, else null (= no pre-order at all)
  function PO() {
    var p = window.RB_PO;
    return p && p.on === true && p.key && p.val && p.btn ? p : null;
  }
  function hasPo() { return !!PO() && data.vs.some(function (v) { return v.po === true; }); }
  function allPo(list) { return list.length > 0 && list.every(function (v) { return v.po === true; }); }
  // Is this size pre-order? Asked of the variant a tap on it would give, with the colour it then lands on (settle()
  // moves a colour this size doesn't have to the first one it has). With another must-pick option still open: only
  // when every variant it could become is pre-order. sel is restored before returning.
  function poOf(o, val) {
    var keep = sel[o.i], to = {};
    sel[o.i] = val;
    data.o.forEach(function (o2) {
      var x = sel[o2.i];
      if (o2.i !== o.i && !o2.s && !fixed[o2.i] && x != null && !avail(o2, x)) x = firstAvail(o2);
      to[o2.i] = x;
    });
    sel[o.i] = keep;
    return allPo(data.vs.filter(function (v) {
      return v.a && data.o.every(function (o2) { return to[o2.i] == null || v.o[o2.i] === to[o2.i]; });
    }));
  }
  // The same for a size in an item row (items 2..N): with the row's colour when it has this size, else any colour
  function rowPoOf(row, o, val) {
    var all = data.vs.filter(function (v) { return v.a && v.o[o.i] === val; });
    var mine = all.filter(function (v) {
      return data.o.every(function (o2) { return o2.i === o.i || o2.v.length < 2 || !row.sel[o2.i] || v.o[o2.i] === row.sel[o2.i]; });
    });
    return allPo(mine.length ? mine : all);
  }
  // Does what the button would add hold a pre-order variant? Item 1 (the pills), and with a set every row as well.
  function poChosen() {
    if (!hasPo()) return false;
    var v = pick();
    if (v && v.po === true) return true;
    return qty > 1 && rows.some(function (row) { var rv = rowVariant(row); return !!(rv && rv.po === true); });
  }
  // The note box right above the add button. Only touched when its state flips, so the note is read out once.
  function paintPo(on) {
    if (!poEl) return;
    var P = PO();
    on = !!(on && P && P.note);
    if (on === !!poEl.firstChild) return;
    poEl.textContent = '';
    if (on) {
      // Nov 1 (make pre-order super clear): the first sentence, with the date, in bold; the words are RB_PO's own
      var p = el('p', 'rb-qa__ponote'), cut = P.note.indexOf('. ');
      if (cut > 0) { p.appendChild(el('strong', null, P.note.slice(0, cut + 1))); p.appendChild(document.createTextNode(' ' + P.note.slice(cut + 2))); }
      else p.textContent = P.note;
      poEl.appendChild(p);
    }
  }

  /* ---------- sets: tiers, prices, and the rows for items 2..N ---------- */
  // Valid tiers only (2..10 items, a price), smallest first. No unit price in the data = no sets (can't show savings).
  // ShoppingIL (Nov 2026): w = the set price itself while the sale is on (the tier's third number), else null.
  function readTiers(d) {
    var seen = {};
    if (d.c == null || !Array.isArray(d.ts)) return [];
    return d.ts.filter(function (t) {
      if (!Array.isArray(t)) return false;
      var n = Number(t[0]), c = Number(t[1]);
      if (!(n >= 2 && n <= 10 && n % 1 === 0 && c > 0) || seen[n]) return false;
      seen[n] = true;
      return true;
    }).map(function (t) {
      var w = t.length > 2 ? Math.round(Number(t[2])) : null;
      return { n: Number(t[0]), c: Math.round(Number(t[1])), w: w > 0 ? w : null };
    }).sort(function (a, b) { return a.n - b.n; });
  }
  function tierOf(n) { return tiers.filter(function (t) { return t.n === n; })[0] || null; }
  function priceVaries() { return data.vs.some(function (v) { return v.c != null; }); }
  // The price one item costs: the picked variant's, else the first available one's (as on the product page).
  function unitCents() { var v = pick(); return v && v.c != null ? v.c : (data.c != null ? data.c : null); }
  // "הכי משתלם": the set with the lowest price per item that really saves (the largest set, with today's prices)
  function bestTier(u) {
    var best = null;
    tiers.forEach(function (t) {
      if (u == null || u * t.n - t.c <= 0) return;
      if (!best || t.c / t.n < best.c / best.n || (t.c / t.n === best.c / best.n && t.n > best.n)) best = t;
    });
    return best;
  }
  // How many items can still be bought at all (any size/colour, minus what's in the drawer)
  function capacity() {
    return data.vs.reduce(function (s, v) {
      if (!v.a) return s;
      return s + (v.q == null ? Infinity : Math.max(0, v.q - inCart(v.id)));
    }, 0);
  }
  // The options a row asks for (an option with one value needs no select)
  function rowOpts() { return data.o.filter(function (o) { return o.v.length > 1; }); }
  // Same rule as avail(), for one row; a row has no fixed colour (a set can mix colours, even from a colour card)
  function rowAvail(row, o, val) {
    return data.vs.some(function (v) {
      if (!v.a || v.o[o.i] !== val) return false;
      return data.o.every(function (o2) {
        if (o2.i === o.i || o2.v.length < 2) return true;
        if (o.s || !o2.s) return true;
        return !row.sel[o2.i] || v.o[o2.i] === row.sel[o2.i];
      });
    });
  }
  function rowVariant(row) {
    if (!data.o.length) return data.vs[0] || null;
    return data.vs.filter(function (v) {
      return data.o.every(function (o) { return o.v.length < 2 || (!!row.sel[o.i] && v.o[o.i] === row.sel[o.i]); });
    })[0] || null;
  }
  function describe(get) {
    return data.o.filter(function (o) { return o.v.length > 1; }).map(function (o) {
      var x = valOf(o, get(o)); return x ? x.l : '';
    }).filter(Boolean).join(' · ');
  }
  // Rows copy item 1 for every option the shopper hasn't changed in that row. A size nobody has any more is dropped;
  // a colour the row's size doesn't have moves to the first one it has (it's then the row's own choice, said once).
  function syncRows() {
    var notes = [];
    rows.forEach(function (row) {
      rowOpts().forEach(function (o) {
        if (!row.own[o.i]) row.sel[o.i] = sel[o.i] == null ? '' : sel[o.i];
      });
      rowOpts().forEach(function (o) {
        if (o.s && row.sel[o.i] && !rowAvail(row, o, row.sel[o.i])) row.sel[o.i] = '';
      });
      rowOpts().forEach(function (o) {
        if (o.s || !row.sel[o.i] || rowAvail(row, o, row.sel[o.i])) return;
        var nv = o.v.filter(function (x) { return rowAvail(row, o, x.v); })[0];
        if (!nv || nv.v === row.sel[o.i]) return;
        var old = valOf(o, row.sel[o.i]);
        notes.push(S.item.replace('[n]', row.n) + ': ' + S.moved.replace('[old]', old ? old.l : row.sel[o.i]).replace('[new]', nv.l));
        row.sel[o.i] = nv.v;
        row.own[o.i] = true;
      });
    });
    return notes;
  }

  function setup(btn) {
    sel = {}; fixed = {}; cardFixed = {};
    qty = 1; rows = []; rowsAll = []; rowNotes = [];
    tiers = readTiers(data);
    var fc = btn.getAttribute('data-rb-qa-color');
    var pre = (btn.getAttribute('data-rb-qa-preset') || '').trim().toLowerCase();
    data.o.forEach(function (o) {
      sel[o.i] = null;
      if (o.v.length === 1) { sel[o.i] = o.v[0].v; fixed[o.i] = true; }
      else if (!o.s && fc !== null && valOf(o, fc)) { sel[o.i] = fc; fixed[o.i] = true; cardFixed[o.i] = true; }
    });
    // colours that aren't fixed: the card's own colour when it's in stock, else the first one in stock
    data.o.forEach(function (o) {
      if (o.s || fixed[o.i]) return;
      var p = pre && o.v.filter(function (x) { return x.v.toLowerCase() === pre || String(x.l).toLowerCase() === pre; })[0];
      sel[o.i] = (p && avail(o, p.v)) ? p.v : firstAvail(o);
    });
  }
  // After a size is picked: a colour that this size doesn't have moves to the first one that it has (and says so).
  function settle() {
    var moved = null;
    data.o.forEach(function (o) {
      if (o.s || fixed[o.i] || sel[o.i] == null || avail(o, sel[o.i])) return;
      var nv = firstAvail(o);
      if (nv && nv !== sel[o.i]) {
        if (!moved) moved = S.moved.replace('[old]', valOf(o, sel[o.i]).l).replace('[new]', valOf(o, nv).l);
        sel[o.i] = nv;
      }
    });
    note(moved || '');
  }
  // Row colour moves are collected by decorate() and said once, after the sheet's own note
  function flushNotes() {
    if (!rowNotes.length) return;
    var t = [noteEl.textContent].concat(rowNotes).filter(Boolean).join(' ');
    rowNotes = [];
    note(t);
  }
  // Mirror sel onto the radios, mark sold-out values. Returns true when a picked size had to be dropped.
  function decorate() {
    var dropped = false;
    var had = document.activeElement;
    data.o.forEach(function (o) {
      if (fixed[o.i]) return;
      $$('input[data-i="' + o.i + '"]', bodyEl).forEach(function (inp) {
        var ok = avail(o, inp.value);
        var on = sel[o.i] === inp.value;
        if (!ok && on && o.s) { sel[o.i] = null; on = false; dropped = true; }
        inp.checked = on;
        inp.disabled = !ok && !on;
        var lab = inp.nextElementSibling;
        if (lab) {
          lab.classList.toggle('is-out', !ok);
          var so = $('.rb-qa__so', lab);
          if (so) so.hidden = ok;
          // ShoppingIL: the "הזמנה מוקדמת" line (only built for sizes of products with pre-order variants)
          var pl = $('.rb-qa__po', lab);
          if (pl) {
            var isPo = ok && poOf(o, inp.value);
            pl.hidden = !isPo;
            lab.classList.toggle('is-po', isPo);
          }
        }
      });
    });
    // a focused pill that just got disabled would drop focus out of the sheet
    if (had && had.disabled && bodyEl.contains(had)) {
      focusEl($('input[name="' + had.name + '"]:not(:disabled)', bodyEl) || addBtn);
    }
    if (qty > 1) {
      rowNotes = rowNotes.concat(syncRows());
      paintRows();
    }
    showVariant();
    return dropped;
  }
  function showVariant() {
    var v = pick();
    // ShoppingIL: the price line is built whole (data-rb-qa-price is the <p>): "₪110", or on sale "₪82.50 ₪110"
    var own = !!(v && v.p), now = (own ? v.p : data.p) || '', was = own ? v.wp : data.wp;
    priceEl.textContent = '';
    if (now) priceEl.appendChild(saleEl(now, was));
    var src = data.img;
    data.o.forEach(function (o) {
      if (o.s || sel[o.i] == null) return;
      var x = valOf(o, sel[o.i]);
      if (x && x.im) src = x.im;
    });
    if (src) { if (imgEl.getAttribute('src') !== src) imgEl.setAttribute('src', src); imgEl.hidden = false; }
    else { imgEl.removeAttribute('src'); imgEl.hidden = true; }
    paintTiers();
    paintAdd();
  }
  // The "כמות" tiles. Rebuilt label by label (the radios themselves stay, so focus and the checked state stay).
  // Nov 2, 2026: name, the price to pay and, on the best set, "הכי משתלם"; nothing else (see the note at the top).
  // Accessible name, e.g.: "סט של 3, ₪309, הכי משתלם"; on sale "סט של 3, ₪231.75, הכי משתלם" (the struck set price is
  // on the add button once the set is picked).
  function paintTiers() {
    if (!tiers.length) return;
    var u = unitCents(), best = bestTier(u), cap = capacity();
    $$('input[data-qty]', bodyEl).forEach(function (inp) {
      var n = Number(inp.value), t = n > 1 ? tierOf(n) : null, lab = inp.nextElementSibling;
      if (!lab) return;
      var on = n === qty, ok = n <= cap;
      inp.checked = on;
      inp.disabled = !ok && !on;
      lab.textContent = '';
      lab.classList.toggle('is-out', !ok);
      lab.appendChild(el('span', 'rb-qa__tname', t ? S.set.replace('[n]', n) : S.one));
      var total = t ? t.c : (priceVaries() && !pick() ? null : u);
      if (total != null) {
        var pr = el('span', 'rb-qa__tprice');
        pr.appendChild(pause());
        pr.appendChild(moneyEl(total));
        lab.appendChild(pr);
      }
      if (t && t === best && ok) {
        var b = el('span', 'rb-qa__badge');
        b.appendChild(pause());
        b.appendChild(document.createTextNode(S.best));
        lab.appendChild(b);
      }
      if (!ok) {
        var so = el('span', 'rb-qa__so');
        so.appendChild(pause());
        so.appendChild(document.createTextNode(S.sold));
        lab.appendChild(so);
      }
    });
  }
  // "הוספה לסל · ₪309": the total of what will be added (no total while it isn't known yet).
  // P3: no size yet = "בחרו מידה", the pale look and aria-disabled (still clickable: add() then says why).
  // ShoppingIL: on sale "הוספה לסל · ₪231.75 ₪309" (the regular price struck); with a pre-order variant in what will be
  // added, "הזמנה מוקדמת · ₪82.50 ₪110" and the pre-order note above the button.
  function paintAdd() {
    var m = missing();
    addBtn.classList.toggle('is-pending', !!m);
    syncAria();
    if (m) {
      addBtn.textContent = '';
      addBtn.appendChild(el('span', null, S.pick.replace('[name]', lc(m.n))));
      paintPo(false);
      return;
    }
    var total = null, was = null;
    if (qty > 1) { var t = tierOf(qty); total = t ? t.c : null; was = t ? t.w : null; }
    else {
      var v = pick();
      if (v && v.c != null) { total = v.c; was = v.wc; }
      else if (!priceVaries() && data.c != null) { total = data.c; was = data.wc; }
    }
    var po = poChosen();
    addBtn.textContent = '';
    addBtn.appendChild(el('span', null, po ? PO().btn : S.add));
    if (total != null) { dotSep(addBtn); addBtn.appendChild(pricePair(total, was)); }
    paintPo(po);
  }

  /* ---------- building the sheet ---------- */
  // Nov 2, 2026: the unit the numbered values of a must-pick option share ("חודשים" in "0-3 חודשים" … "18-24 חודשים"),
  // else ''. A value with no digit ("ניו בורן", "Newborn", "XS") is shown whole and doesn't count; every numbered value
  // must be "<number> <unit>" with the same unit, and at least two of them, or nothing is shortened.
  function unitOf(o) {
    if (!o.s || o.v.length < 2) return '';
    var u = '', n = 0;
    for (var k = 0; k < o.v.length; k++) {
      var w = String(o.v[k].l || '').trim().split(/\s+/);
      if (!/\d/.test(w[0])) continue;
      if (w.length !== 2 || (u && w[1] !== u)) return '';
      u = w[1];
      n++;
    }
    return n > 1 ? u : '';
  }
  function dot(w) {
    var d = el('span', 'rb-qa__dot');
    d.setAttribute('aria-hidden', 'true');
    if (/^url\(/i.test(w)) d.style.backgroundImage = w; else d.style.backgroundColor = w;
    return d;
  }
  // "· פריט 1" after a legend while a set is picked: the pills are item 1's
  function forMark() {
    var s = el('span', 'rb-qa__for');
    s.hidden = qty < 2;
    dotSep(s);
    s.appendChild(document.createTextNode(S.item.replace('[n]', 1)));
    forEls.push(s);
    return s;
  }
  function buildQty() {
    var fs = el('fieldset', 'rb-qa__set rb-qa__set--qty');
    fs.setAttribute('role', 'radiogroup');
    fs.setAttribute('aria-labelledby', 'RBQA-QtyL');
    var lg = el('legend', 'rb-qa__legend', S.qty);
    lg.id = 'RBQA-QtyL';
    fs.appendChild(lg);
    var wrap = el('div', 'rb-qa__opts rb-qa__opts--qty');
    [1].concat(tiers.map(function (t) { return t.n; })).forEach(function (n) {
      var box = el('span', 'rb-qa__opt rb-qa__tier');
      var inp = document.createElement('input');
      inp.type = 'radio';
      inp.id = 'RBQA-q-' + n;
      inp.name = 'RBQA-qty';
      inp.value = String(n);
      inp.setAttribute('data-qty', n);
      var lab = document.createElement('label');
      lab.htmlFor = inp.id;
      box.appendChild(inp);
      box.appendChild(lab);
      wrap.appendChild(box);
    });
    fs.appendChild(wrap);
    bodyEl.appendChild(fs);
  }
  // Items 2..N: one row each, a native <select> per option (compact: three rows of pills wouldn't fit a phone sheet,
  // and these are only changed when the shopper wants a mix). Item 1 is a plain line: it follows the pills above.
  function buildRows() {
    forEls.forEach(function (f) { f.hidden = qty < 2; });
    if (!itemsEl) return;
    itemsEl.textContent = '';
    itemsEl.hidden = qty < 2 || !rowOpts().length;
    rows.forEach(function (row) { row.el = null; });
    if (itemsEl.hidden) return;
    itemsEl.setAttribute('aria-label', S.set.replace('[n]', qty));
    // two selects (size + colour): on phones the "פריט N" label goes above them, so both stay readable at 390px
    var cls = 'rb-qa__item' + (rowOpts().length > 1 ? ' rb-qa__item--multi' : '');
    var r1 = el('div', cls + ' rb-qa__item--first');
    r1.appendChild(el('span', 'rb-qa__item-n', S.item.replace('[n]', 1)));
    r1.appendChild(el('span', 'rb-qa__item-v'));
    itemsEl.appendChild(r1);
    rows.forEach(function (row) {
      var r = el('div', cls);
      r.appendChild(el('span', 'rb-qa__item-n', S.item.replace('[n]', row.n)));
      rowOpts().forEach(function (o) {
        var w = el('span', 'rb-qa__sel');
        var s = document.createElement('select');
        s.id = 'RBQA-r' + row.n + '-' + o.i;
        s.setAttribute('data-row', row.n);
        s.setAttribute('data-i', o.i);
        s.setAttribute('aria-label', S.item.replace('[n]', row.n) + ' – ' + o.n);   // "פריט 2 – מידה"
        if (o.s) { var ph = el('option', null, S.ph.replace('[name]', lc(o.n))); ph.value = ''; s.appendChild(ph); }
        o.v.forEach(function (x) { var op = el('option', null, x.l); op.value = x.v; s.appendChild(op); });
        w.appendChild(s);
        r.appendChild(w);
      });
      row.el = r;
      itemsEl.appendChild(r);
    });
  }
  // Rows' selects mirror row.sel; sold-out values are disabled and read "– אזל".
  // ShoppingIL: a pre-order size reads "– הזמנה מוקדמת" (still enabled: it's buyable).
  function paintRows() {
    if (!itemsEl || itemsEl.hidden) return;
    var poLine = hasPo() ? PO().pill : '';
    var v1 = $('.rb-qa__item-v', itemsEl);
    if (v1) {
      var m = missing();
      v1.textContent = m ? S.above.replace('[name]', lc(m.n)) : describe(function (o) { return sel[o.i]; });
      v1.classList.toggle('is-empty', !!m);
    }
    rows.forEach(function (row) {
      if (!row.el) return;
      $$('select', row.el).forEach(function (s) {
        var o = optOf(Number(s.getAttribute('data-i')));
        if (!o) return;
        $$('option', s).forEach(function (op) {
          if (!op.value) return;
          var ok = rowAvail(row, o, op.value), x = valOf(o, op.value);
          var isPo = ok && !!poLine && o.s && rowPoOf(row, o, op.value);
          op.disabled = !ok;
          op.textContent = (x ? x.l : op.value) + (ok ? (isPo ? ' – ' + poLine : '') : ' – ' + S.sold);
        });
        var want = row.sel[o.i] || '';
        if (s.value !== want) s.value = want;
      });
    });
  }
  function setQty(n) {
    n = n > 1 && tierOf(n) ? n : 1;
    if (n === qty) return;
    qty = n;
    while (rowsAll.length < qty - 1) rowsAll.push({ n: rowsAll.length + 2, sel: {}, own: {}, el: null });
    rows = rowsAll.slice(0, qty - 1);
    buildRows();
    msg(''); note('');
    decorate();
    flushNotes();
  }
  function build() {
    bodyEl.textContent = '';
    forEls = []; itemsEl = null;
    var poLine = hasPo() ? PO().pill : '';   // ShoppingIL: sizes of a product with pre-order variants get the line
    if (tiers.length) buildQty();
    data.o.forEach(function (o) {
      if (fixed[o.i]) {
        var fv = valOf(o, sel[o.i]);
        if (!fv || fv.v === 'Default Title') return;
        var p = el('p', 'rb-qa__fixed');
        p.appendChild(el('span', 'rb-qa__fixed-k', o.n + ':'));
        if (fv.w) p.appendChild(dot(fv.w));
        p.appendChild(el('strong', null, fv.l));
        if (cardFixed[o.i] && tiers.length) p.appendChild(forMark());   // the card's colour is item 1's; rows can mix
        bodyEl.appendChild(p);
        return;
      }
      var fs = el('fieldset', 'rb-qa__set' + (o.s ? ' rb-qa__set--size' : ''));
      var lg = el('legend', 'rb-qa__legend');
      var unit = unitOf(o);   // Nov 2: "מידה (חודשים)", pills "0-3"
      lg.appendChild(el('span', null, unit ? o.n + ' (' + unit + ')' : o.n));
      if (tiers.length) lg.appendChild(forMark());
      fs.appendChild(lg);
      var wrap = el('div', 'rb-qa__opts');
      o.v.forEach(function (x, k) {
        var id = 'RBQA-' + o.i + '-' + k;
        var box = el('span', 'rb-qa__opt');
        var inp = document.createElement('input');
        inp.type = 'radio';
        inp.id = id;
        inp.name = 'RBQA-' + o.i;
        inp.value = x.v;
        inp.setAttribute('data-i', o.i);
        var lab = document.createElement('label');
        lab.htmlFor = id;
        if (x.w) lab.appendChild(dot(x.w));
        var xw = String(x.l).trim().split(/\s+/);
        if (unit && xw.length === 2 && xw[1] === unit && /\d/.test(xw[0])) {
          // "0-3" left to right; the unit for screen readers only (the legend shows it once)
          var tt = el('span', 'rb-qa__t'), num = el('span', null, xw[0]);
          num.setAttribute('dir', 'ltr');
          tt.appendChild(num);
          tt.appendChild(el('span', 'visually-hidden', ' ' + unit));
          lab.appendChild(tt);
        } else {
          lab.appendChild(el('span', 'rb-qa__t', x.l));
        }
        // ShoppingIL: "הזמנה מוקדמת", a second smaller line under the size (shown by decorate() when it applies)
        if (poLine && o.s) {
          var pl = el('span', 'rb-qa__po');
          pl.hidden = true;
          pl.appendChild(el('span', 'visually-hidden', ', '));
          pl.appendChild(document.createTextNode(poLine));
          lab.appendChild(pl);
        }
        var so = el('span', 'rb-qa__so');
        so.hidden = true;
        so.appendChild(el('span', 'visually-hidden', ', '));
        so.appendChild(document.createTextNode(S.sold));
        lab.appendChild(so);
        box.appendChild(inp);
        box.appendChild(lab);
        wrap.appendChild(box);
      });
      fs.appendChild(wrap);
      bodyEl.appendChild(fs);
    });
    if (tiers.length) {
      itemsEl = el('div', 'rb-qa__items');
      itemsEl.setAttribute('role', 'group');
      itemsEl.hidden = true;
      bodyEl.appendChild(itemsEl);
    }
    titleEl.textContent = data.t;
    pdpEl.setAttribute('href', opener.getAttribute('data-url') || data.u);
    note(''); msg('');
    decorate();
  }
  // P3: with no size picked, a tap open puts focus on the title (a focus ring on the first pill looked like a size
  // chosen for the shopper); a keyboard open (kb) still lands on the first size pill.
  function firstFocus(kb) {
    var req = data.o.filter(function (o) { return o.s && !fixed[o.i]; })[0];
    if (req) {
      var c = $('input[data-i="' + req.i + '"]:checked', bodyEl);
      if (c) return c;
      if (kb) { c = $('input[data-i="' + req.i + '"]:not(:disabled)', bodyEl); if (c) return c; }
      return titleEl;
    }
    return addBtn;
  }

  /* ---------- availability re-check (the page, and so its JSON, may be cached) ---------- */
  function refreshAvail(d, force) {
    if (!window.fetch || !d.u) return;
    if (!force && d._at && Date.now() - d._at < 60000) return;
    d._at = Date.now();
    var ctl = window.AbortController ? new AbortController() : null;
    var timer = setTimeout(function () { if (ctl) ctl.abort(); }, 6000);
    window.fetch(String(d.u).split(/[?#]/)[0] + '.js', {
      headers: { Accept: 'application/json' }, credentials: 'same-origin', signal: ctl ? ctl.signal : undefined
    }).then(function (r) { return r.ok ? r.json() : null; }).then(function (j) {
      clearTimeout(timer);
      if (!j || !Array.isArray(j.variants)) return;
      var now = {}, changed = false;
      j.variants.forEach(function (v) { now[v.id] = !!v.available; });
      d.vs.forEach(function (v) { if (v.id in now && v.a !== now[v.id]) { v.a = now[v.id]; changed = true; } });
      if (!changed || !dlg.open || data !== d || busy) return;
      var dropped = decorate();   // a picked size that just sold out is dropped
      settle();                   // a colour the picked size no longer has moves on
      decorate();
      flushNotes();
      if (dropped) msg(S.gone);
    }, function () { clearTimeout(timer); d._at = 0; });
  }

  /* ---------- open / close ---------- */
  function open(btn, kb) {
    if (dlg.open) return;
    var d = productData(btn.getAttribute('data-rb-qa-open'), btn);
    if (!d) { go(btn.getAttribute('data-url')); return; }
    data = d; opener = btn; handoff = false;
    addRun++;
    setBusy(false);
    setup(btn);
    build();
    document.documentElement.classList.add('rb-qa-lock');
    try { dlg.showModal(); } catch (e) {
      document.documentElement.classList.remove('rb-qa-lock');
      go(btn.getAttribute('data-url') || d.u);
      return;
    }
    focusEl(firstFocus(kb));
    emit('rb:qa:open', { product: d.id });
    refreshAvail(d);
  }
  // While an add runs, closing waits (so the drawer doesn't pop up after the sheet was dismissed), but only for
  // LOCK_MS: on a stalled connection the shopper can always get out (X, backdrop, Esc). A late success then still
  // opens the drawer, which confirms the add.
  function locked() { return busy && Date.now() - busyAt < LOCK_MS; }
  function close() { if (dlg.open && !locked()) dlg.close(); }
  function onClosed() {
    document.documentElement.classList.remove('rb-qa-lock');
    var ho = handoff;
    handoff = false;
    emit('rb:qa:close', { product: data && data.id });
    // after an add, RB Cart has focus (and gives it back to the tile when the drawer closes)
    if (!ho && opener && opener.isConnected) focusEl(opener);
  }

  /* ---------- add ---------- */
  function setBusy(on) {
    busy = on;
    busyAt = on ? Date.now() : 0;
    addBtn.classList.toggle('is-loading', on);
    syncAria();
  }
  // aria-disabled while an add runs, or while a size is still missing (P3); the button itself is never disabled
  function syncAria() {
    if (busy || addBtn.classList.contains('is-pending')) addBtn.setAttribute('aria-disabled', 'true');
    else addBtn.removeAttribute('aria-disabled');
  }
  // Mark a row's select as the one to fix and move focus there (the alert then says what's wrong). Any change in the
  // sheet clears the marks (the problem may be fixed in another row, e.g. a stock limit).
  function clearFlags() {
    if (itemsEl) $$('select[aria-invalid]', itemsEl).forEach(function (x) { x.removeAttribute('aria-invalid'); });
  }
  function flagRow(row, o) {
    var s = row && row.el && ((o && $('select[data-i="' + o.i + '"]', row.el)) || $('select', row.el));
    if (!s) return;
    s.setAttribute('aria-invalid', 'true');
    focusEl(s);
    reveal(s);
  }
  // focusEl() never scrolls (preventScroll), and on a phone a set's rows sit below the fold, under the sticky add
  // button. Scroll the sheet itself (not the page) so the control to fix is in view and clear of the footer.
  function reveal(e) {
    if (!e || !e.getBoundingClientRect || !dlg.getBoundingClientRect) return;
    try {
      var r = e.getBoundingClientRect(), d = dlg.getBoundingClientRect();
      var foot = $('.rb-qa__foot', dlg), fh = foot ? (foot.getBoundingClientRect().height || 0) : 0;
      var top = d.top, bottom = d.bottom - fh, h = (r.bottom - r.top) || 0;
      if (r.top >= top && r.bottom <= bottom) return;
      dlg.scrollTop = (dlg.scrollTop || 0) + (r.top - top) - Math.max(0, (bottom - top - h) / 2);
    } catch (x) {}
  }
  // What goes in the cart: item 1 (the pills), then each row; identical variants grouped into one {id, quantity}.
  // Returns {items} or {error, row, opt} (row null = item 1).
  function collect() {
    var v = pick();
    if (!v || !v.a) return { error: S.soldOpt };
    var list = [{ v: v, row: null }];
    for (var k = 0; qty > 1 && k < rows.length; k++) {
      var row = rows[k], rv = rowVariant(row);
      if (!rv) {
        var mo = rowOpts().filter(function (o) { return !row.sel[o.i]; })[0] || rowOpts()[0];
        return { error: S.rowNeed.replace('[name]', lc(mo ? mo.n : '')).replace('[n]', row.n), row: row, opt: mo };
      }
      if (!rv.a) return { error: S.item.replace('[n]', row.n) + ': ' + S.soldOpt, row: row, opt: rowOpts()[0] };
      list.push({ v: rv, row: row });
    }
    var items = [], by = {};
    list.forEach(function (x) {
      if (!by[x.v.id]) { by[x.v.id] = { id: x.v.id, quantity: 0, v: x.v, rows: [] }; items.push(by[x.v.id]); }
      by[x.v.id].quantity++;
      by[x.v.id].rows.push(x.row);
    });
    // Never ask for more than is left (Shopify would add part of it AND report an error)
    for (var j = 0; j < items.length; j++) {
      var it = items[j];
      if (it.v.q == null) continue;
      var left = it.v.q - inCart(it.id);
      var last = it.rows.filter(Boolean).pop() || null;
      if (left <= 0) return { error: S.max.replace('[n]', Math.max(0, it.v.q)), row: last, opt: rowOpts()[0] };
      if (it.quantity > left) {
        var what = describe(function (o) { return it.v.o[o.i]; }) || data.t;
        return { error: S.setMax.replace('[what]', what).replace('[n]', left), row: last, opt: rowOpts()[0] };
      }
    }
    // ShoppingIL: each pre-order variant carries the line property "הזמנה מוקדמת" = "יישלח עד 24.11" (RB_PO.key / val,
    // no underscore, so checkout, the order, Flow and the emails show it). Identical variants are one item, so one line.
    var P = PO();
    return { items: items.map(function (x) {
      var it = { id: x.id, quantity: x.quantity };
      if (P && x.v.po === true) { it.properties = {}; it.properties[P.key] = P.val; }
      return it;
    }), first: v };
  }
  function add() {
    if (busy) return;
    msg('');
    var m = missing();
    if (m) {
      if (!m.v.some(function (x) { return avail(m, x.v); })) { msg(S.soldOpt); return; }
      msg(S.need.replace('[name]', lc(m.n)));   // "Please choose a size" (Hebrew has no case)
      var mf = $('input[data-i="' + m.i + '"]:not(:disabled)', bodyEl);
      focusEl(mf);
      reveal(mf);   // with a set's rows open the sheet may be scrolled down, past the size pills
      return;
    }
    var r = collect();
    if (r.error) {
      if (r.row) flagRow(r.row, r.opt);
      msg(r.error);
      return;
    }
    if (!cartReady()) {
      // the product page has the same set picker
      go(String(opener.getAttribute('data-url') || data.u).split(/[?#]/)[0] + '?variant=' + r.first.id);
      return;
    }
    setBusy(true);
    var tile = opener, d = data, run = addRun, isSet = qty > 1;
    window.RBCart.add(r.items, { source: isSet ? 'quick-add-set' : 'tile', open: false }).then(function () {
      if (run !== addRun) return;   // another tile's sheet was opened since (after a stalled add): leave it alone
      setBusy(false);
      if (dlg.open) { handoff = true; dlg.close(); }
      // the drawer opens only now, so it isn't stuck under the modal; its live region says "נוסף לעגלה"
      window.RBCart.open(tile && tile.isConnected ? tile : null);
    }, function (e) {
      if (run !== addRun) return;
      setBusy(false);
      msg(errText(e));
      if (e && e.httpStatus === 422) refreshAvail(d, true);
    });
  }

  /* ---------- tiles: link → button, once RB Cart is ready ---------- */
  function upgrade(scope) {
    $$('a[data-rb-qa-open]', scope).forEach(function (a) {
      if (!productData(a.getAttribute('data-rb-qa-open'), a)) return;   // no data: it stays a link to the product
      var b = document.createElement('button');
      b.type = 'button';
      Array.prototype.forEach.call(a.attributes, function (at) { if (at.name !== 'href') b.setAttribute(at.name, at.value); });
      b.setAttribute('data-url', a.getAttribute('href') || '');
      b.setAttribute('aria-haspopup', 'dialog');
      while (a.firstChild) b.appendChild(a.firstChild);
      var had = document.activeElement === a;
      a.parentNode.replaceChild(b, a);
      if (had) focusEl(b);
    });
  }

  /* ---------- wiring ---------- */
  function trap(e) {
    if (e.key !== 'Tab') return;
    var f = $$('button:not([disabled]), a[href], input:not([disabled]), select:not([disabled])', dlg).filter(function (x) {
      return !x.closest('[hidden]') && x.getClientRects().length > 0;
    });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1], a = document.activeElement;
    if (e.shiftKey && (a === first || a === dlg || a === titleEl)) { e.preventDefault(); focusEl(last); }
    else if (!e.shiftKey && a === last) { e.preventDefault(); focusEl(first); }
  }
  function outside(e) {
    var r = dlg.getBoundingClientRect();
    return e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom;
  }
  function onRowChange(s) {
    var n = Number(s.getAttribute('data-row'));
    var row = rows.filter(function (x) { return x.n === n; })[0];
    var o = optOf(Number(s.getAttribute('data-i')));
    if (!row || !o) return;
    row.sel[o.i] = s.value;
    row.own[o.i] = true;   // this row stops copying item 1 for this option
    clearFlags();
    msg(''); note('');
    decorate();
    flushNotes();
  }
  function init() {
    dlg = document.getElementById('RBQA');
    if (!dlg || typeof dlg.showModal !== 'function') return;   // no <dialog> support: tiles keep their links
    bodyEl = $('[data-rb-qa-body]', dlg); titleEl = $('#RBQA-Title', dlg); priceEl = $('[data-rb-qa-price]', dlg);
    imgEl = $('[data-rb-qa-img]', dlg); noteEl = $('[data-rb-qa-note]', dlg); msgEl = $('[data-rb-qa-msg]', dlg);
    addBtn = $('[data-rb-qa-add]', dlg); pdpEl = $('[data-rb-qa-pdp]', dlg);
    poEl = $('[data-rb-qa-po]', dlg);   // ShoppingIL: only printed while pre-order is on (optional)
    if (!bodyEl || !titleEl || !priceEl || !imgEl || !noteEl || !msgEl || !addBtn || !pdpEl) return;
    try { S = JSON.parse((document.getElementById('RBQA-Strings') || {}).textContent || '{}'); } catch (e) { S = {}; }
    S.need = S.need || 'Please choose a [name]';
    S.sold = S.sold || 'Sold out';
    S.soldOpt = S.soldOpt || 'That option is sold out';
    S.gone = S.gone || S.soldOpt;
    S.moved = S.moved || '[old] is sold out in this size, so we picked [new].';
    S.max = S.max || 'Only [n] available';
    S.err = S.err || 'Something went wrong. Please try again.';
    S.add = S.add || addBtn.textContent.trim() || 'Add to cart';
    S.qty = S.qty || 'Quantity';
    S.one = S.one || '1 item';
    S.set = S.set || 'Set of [n]';
    S.best = S.best || 'Best value';
    S.item = S.item || 'Item [n]';
    S.above = S.above || 'Choose a [name] above';
    S.ph = S.ph || 'Choose [name]';
    S.rowNeed = S.rowNeed || 'Please choose a [name] for item [n]';
    S.setMax = S.setMax || '[what]: only [n] left. Please change the size or colour of one of the items.';
    S.pick = S.pick || S.ph || 'Choose [name]';
    S.was = S.was || 'was';         // ShoppingIL: the struck price, as snippets/rb-money says it
    if (!titleEl.hasAttribute('tabindex')) titleEl.setAttribute('tabindex', '-1');   // P3: focus target on open
    if (!cartReady()) return;   // e.g. RB Cart failed to load: tiles keep their product links

    upgrade(document);
    document.addEventListener('click', function (e) {
      var b = e.target && e.target.closest && e.target.closest('button[data-rb-qa-open]');
      if (!b || e.defaultPrevented) return;
      e.preventDefault();
      open(b, e.detail === 0);   // detail 0 = Enter/Space on the button (keyboard), not a tap or click
    });
    dlg.addEventListener('pointerdown', function (e) { downOutside = e.target === dlg && outside(e); });
    dlg.addEventListener('click', function (e) {
      var t = e.target;
      if (t.closest('[data-rb-qa-close]')) { close(); return; }
      if (t.closest('[data-rb-qa-add]')) { add(); return; }
      if (t === dlg && downOutside && outside(e)) close();   // a tap on the dimmed page
      downOutside = false;
    });
    dlg.addEventListener('cancel', function (e) { if (locked()) e.preventDefault(); });   // Esc waits for a running add
    dlg.addEventListener('close', onClosed);
    dlg.addEventListener('keydown', trap);
    bodyEl.addEventListener('change', function (e) {
      var t = e.target;
      if (!t) return;
      if (t.tagName === 'SELECT' && t.hasAttribute('data-row')) { onRowChange(t); return; }
      if (t.type !== 'radio' || !t.checked) return;
      if (t.hasAttribute('data-qty')) { setQty(Number(t.value)); return; }
      var o = optOf(Number(t.getAttribute('data-i')));
      if (!o) return;
      sel[o.i] = t.value;
      msg('');
      clearFlags();
      if (o.s) settle(); else note('');
      decorate();
      flushNotes();
    });
    // back/forward cache: never come back to a page with the sheet still open
    window.addEventListener('pageshow', function (e) { if (e.persisted && dlg.open) { addRun++; setBusy(false); dlg.close(); } });
    // theme editor: re-rendered sections get their buttons again
    document.addEventListener('shopify:section:load', function (e) { if (e.target) upgrade(e.target); });
  }

  // Deferred, right after rb-cart.js (also deferred), so window.RBCart already exists here.
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* Shopify Inbox chat (<shopify-chat>, open shadow root) renders its window in an <iframe> without a title, which fails
   WCAG 4.1.2 / IS 5568 (frame-title). Give it one once it appears. Gives up after ~30 s; harmless if the chat is off. */
(function () {
  var he = (document.documentElement.lang || '').indexOf('he') === 0;
  var title = he ? 'צ׳אט עם RelliBaby' : 'Chat with RelliBaby';
  var tries = 0;
  function fix(once) {
    var host = document.querySelector('shopify-chat');
    var root = host && host.shadowRoot;
    var done = false;
    if (root) {
      root.querySelectorAll('iframe, shopify-agent-runtime').forEach(function (el) {
        var f = el.tagName === 'IFRAME' ? el : (el.shadowRoot && el.shadowRoot.querySelector('iframe')) || el.querySelector('iframe');
        if (f && !f.getAttribute('title')) f.setAttribute('title', title);
        if (f) done = true;
      });
    }
    if (once !== true && ++tries < 30) setTimeout(fix, done ? 3000 : 1000);
  }
  // The window's iframe is created when the chat is opened, so check again after any tap inside the chat.
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('shopify-chat')) { setTimeout(function () { fix(true); }, 800); setTimeout(function () { fix(true); }, 2500); }
  }, true);
  if (document.readyState === 'complete') fix(); else window.addEventListener('load', fix);
})();

/* Shopify injects <shopify-store language="he-IL"> for the Inbox chat. Its product cards send that to the Storefront API
   as @inContext(language: HE_IL), which is not a valid LanguageCode (Hebrew is HE), so the chat shows a red
   "shopify-context: Argument 'language' … HE_IL" error under product answers. Drop the region for Hebrew. */
(function () {
  function fixLang(el) {
    var l = el.getAttribute('language') || '';
    if (/^he[-_]/i.test(l)) el.setAttribute('language', 'he');
  }
  function scan() { document.querySelectorAll('shopify-store[language]').forEach(fixLang); }
  scan();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  if (document.body && window.MutationObserver) {
    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        m.addedNodes.forEach(function (n) { if (n.nodeType === 1 && n.matches('shopify-store')) fixLang(n); });
      });
    }).observe(document.body, { childList: true });
  }
})();
